import {
  faBell,
  faCalendarPlus,
  faCalendarTimes,
  faCalendarMinus,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import moment from 'moment'
import React, { useState } from 'react'

import { useAppDispatch } from '../../App/Hooks/reduxHooks'

import { INotification } from './interface/INotification'
import style from './Notification.scss'
import { readNotification } from './store/actions'

interface IProps {
  notification: INotification
}

export const Notification = ({ notification }: IProps) => {
  const dispatch = useAppDispatch()
  const [read, setRead] = useState(notification.isRead)

  const classes = [style.notification]
  if (read) {
    classes.push(style.read)
  }

  const icons = {
    bell: faBell,
    calendarPlus: faCalendarPlus,
    calendarMinutes: faCalendarMinus,
    calendarTimes: faCalendarTimes,
  }

  let icon = icons.bell
  if (notification.icon && notification.icon in icons) {
    icon = icons[notification.icon]
  }

  return (
    <a
      href={notification.action ? notification.action : '#'}
      className={classes.join(' ')}
      onClick={e => {
        e.preventDefault()
        setRead(true)
        dispatch(readNotification(notification.id)).then(() => {
          if (notification.action) {
            window.location.href = notification.action
          }
        })
      }}>
      <div className={style.iconWrapper}>
        <FontAwesomeIcon icon={icon} />
      </div>
      <div className={style.contentWrapper}>
        <div className={style.subject}>{notification.subject}</div>
        <div className={style.body}>{notification.body}</div>
        <div className={style.time}>
          {moment(notification.createdAt).fromNow()}
        </div>
      </div>
    </a>
  )
}
